import type { AgScrollbarOptions, WithThemeParams } from 'ag-charts-community';

const SCROLLBAR_ORIENTATION_THEME: WithThemeParams<AgScrollbarOptions> = {
    enabled: { $path: '../enabled' },
    thickness: { $path: '../thickness' },
    spacing: { $path: '../spacing' },
    tickSpacing: { $path: '../tickSpacing' },
    placement: { $path: '../placement' },
    visible: { $path: '../visible' },
    track: {
        fill: { $path: '../../track/fill' },
        stroke: { $path: '../../track/stroke' },
        fillOpacity: { $path: '../../track/fillOpacity' },
        strokeWidth: { $path: '../../track/strokeWidth' },
        lineDash: { $path: '../../track/lineDash' },
        lineDashOffset: { $path: '../../track/lineDashOffset' },
        opacity: { $path: '../../track/opacity' },
        cornerRadius: { $path: '../../track/cornerRadius' },
    },
    thumb: {
        fill: { $path: '../../thumb/fill' },
        stroke: { $path: '../../thumb/stroke' },
        fillOpacity: { $path: '../../thumb/fillOpacity' },
        strokeWidth: { $path: '../../thumb/strokeWidth' },
        lineDash: { $path: '../../thumb/lineDash' },
        lineDashOffset: { $path: '../../thumb/lineDashOffset' },
        opacity: { $path: '../../thumb/opacity' },
        cornerRadius: { $path: '../../thumb/cornerRadius' },
        minSize: { $path: '../../thumb/minSize' },
        hoverStyle: {
            fill: { $path: '../../../thumb/hoverStyle/fill' },
            stroke: { $path: '../../../thumb/hoverStyle/stroke' },
        },
    },
};

export const SCROLLBAR_THEME: WithThemeParams<AgScrollbarOptions> = {
    enabled: false,
    thickness: 12,
    spacing: 16,
    tickSpacing: 0,
    placement: 'outer',
    visible: 'auto',
    track: {
        fill: { $foregroundBackgroundMix: 0.03 },
        stroke: { $foregroundBackgroundMix: 0.177 },
        strokeWidth: 1,
        lineDash: [0],
        lineDashOffset: 0,
        opacity: 1,
        cornerRadius: 6,
    },
    thumb: {
        fill: { $foregroundBackgroundMix: 0.125 },
        stroke: { $foregroundBackgroundMix: 0.364 },
        strokeWidth: 1,
        lineDash: [0],
        lineDashOffset: 0,
        opacity: 1,
        cornerRadius: 6,
        minSize: 20,
        hoverStyle: {
            fill: { $mix: [{ $path: '../fill' }, { $ref: 'foregroundColor' }, 0.075] },
            stroke: { $mix: [{ $path: '../stroke' }, { $ref: 'foregroundColor' }, 0.075] },
        },
    },
    vertical: SCROLLBAR_ORIENTATION_THEME,
    horizontal: SCROLLBAR_ORIENTATION_THEME,
};
